var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.047a2 2 0 00-2-2H7.474l-.548-1.67A2 2 0 005.026 0H2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V5.047z",
    fill: "#FFCA5A"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgNS4wNDcyMUMxNiAzLjk0MjY0IDE1LjEwNDYgMy4wNDcyMSAxNCAzLjA0NzIxSDcuNDc0TDYuOTI1NjkgMS4zNzYzOUM2LjY1NjIgMC41NTUxODUgNS44ODk2OSAwIDUuMDI1NCAwSDJDMC44OTU0MzIgMCAwIDAuODk1NDMxIDAgMlYxNEMwIDE1LjEwNDYgMC44OTU0MzEgMTYgMiAxNkgxNEMxNS4xMDQ2IDE2IDE2IDE1LjEwNDYgMTYgMTRWNS4wNDcyMVoiIGZpbGw9IiNGRkNBNUEiLz4KPC9zdmc+Cg==";
export { SvgFolder as ReactComponent };